

export const validateArtists = async (name, value) => {

    switch (name) {
        case 'nombre':
            if (value === '' | value === undefined) return 'nombre vacío'
            if (value.length < 2) return 'nombre demasiado corto'
            return ''
        case 'imagen':
            if (value === '' | value === undefined) return 'imagen vacía'
            return ''
        default:
            return ''
    }

}
export const validateSongs = async (name, value) => {

    switch (name) {
        case 'titulo':
            if (value === '' | value === undefined) return 'título vacío'
            if (value.length < 3) return 'título demasiado corto'
            return ''
        case 'duracion':
            if (value.length !== 5)
                return 'formato de tiempo no válido'
            if (value.charAt(0) === '0' && value.charAt(1) === '0' && value.charAt(3) === '0')
                return 'poca duración del tema'
            return ''
        case 'anyo':
            if (value.toString().length !== 4)
                return 'formato de año no válido'
            if (value < 1900)
                return 'tema demasiado antiguo'
            return ''
        default:
            return ''
    }

}
export const validateVillages = async (name, value) => {

    switch (name) {
        case 'nombre':
            if (value === '' | value === undefined) return 'nombre vacío'
            if (value.length < 3) return 'nombre demasiado corto'
            return ''
        case 'provincia':
            if (value === '' | value === undefined) return 'provincia vacía'
            if (value.length < 3) return 'provincia demasiado corto'
            return ''
        case 'ubicacion':
            if (value === '' | value === undefined) return 'ubicación vacía'
            if (value.length < 3) return 'ubicación demasiado corta'
            return ''
        case 'hora':
            if (value.length !== 5)
                return 'formato de tiempo no válido'
            return ''
        default:
            return ''
    }

}
export const validateVotes = async (name, value) => {

    switch (name) {
        case 'dirip':
            if (value === '' | value === undefined) return 'IP vacía'          
            if (!validateIp(value)) return 'formato de IP no correcto'
            return ''
        default:
            return ''
    }

}
export const validateUsers = async (name, value) => {

    switch (name) {
        case 'nombre':
            console.log(value)
            if (value === '' | value === undefined) return 'nombre vacío'
            if (value.length < 3) return 'nombre demasiado corto'
            return ''
            case 'password':
            console.log(value)
            if (value === '' | value === undefined) return 'password vacío'
            if (value.length < 6) return 'password demasiado corto'
            return ''
            case 'alias':
            console.log(value)
            if (value === '' | value === undefined) return 'alias vacío'
            if (value.length !== 3) return 'alias con 3 letras'
            return ''
        default:
            return ''
    }
}
export const validateLogin = async (name, value) => {

    switch (name) {
        case 'nombre':
            if (value.length < 3) return 'nombre demasiado corto'
            return ''
        case 'password':
            if (value.length < 6) return 'password demasiado corto'
            return ''
        default:
            return ''
    }
}




function validateIp(ip) {
    var patronIp = new RegExp("^([0-9]{1,3}).([0-9]{1,3}).([0-9]{1,3}).([0-9]{1,3})$");
    var valores;

    // early return si la ip no tiene el formato correcto.
    if (ip.search(patronIp) !== 0) {
        return false
    }

    valores = ip.split(".");

    return valores[0] <= 255 && valores[1] <= 255 && valores[2] <= 255 && valores[3] <= 255
}
